import React, { SVGProps } from "react";
import { ZignalyLogotypeLight, ZignalyLogotypeDark } from "@ui/index";
import { useTheme } from "@mui/material";

const ZignalyLogotype = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  return theme.palette.mode === "dark" ? (
    <ZignalyLogotypeDark {...props} />
  ) : (
    <ZignalyLogotypeLight {...props} />
  );
};
export default ZignalyLogotype;
